export interface OrderNumber {
  ordinal: number;
  month: number;
  year: number;
  compare: (orderNumber: OrderNumber) => number;
};

export const parseOrderNumber = (text: string): OrderNumber | null => {
  const capturingGroups = text.match(/^(\d+)\/(\d{2})\/(\d{4})$/);
  return capturingGroups === null
    ? null
    : createOrderNumber(capturingGroups);
};

const createOrderNumber = (capturingGroups: RegExpMatchArray): OrderNumber => {
  const ordinal = Number(capturingGroups[1]);
  const month = Number(capturingGroups[2]);
  const year = Number(capturingGroups[3]);
  return {
    ordinal,
    month,
    year,
    compare: (orderNumber: OrderNumber): number => {
      const yearComparisonResult = year - orderNumber.year
      if (yearComparisonResult === 0) {
        const monthComparisonResult = month - orderNumber.month;
        return monthComparisonResult === 0
          ? ordinal - orderNumber.ordinal
          : monthComparisonResult;
      } else {
        return yearComparisonResult;
      }
    }
  }
};